import { makeStyles } from "@material-ui/core";

export const useCalendarStyles = makeStyles((theme) => ({
  calendarCard: {
    backgroundColor: "#ffffff",
    borderRadius: 16,
    boxShadow: "0 2px 12px rgba(0, 0, 0, 0.06)",
    padding: theme.spacing(2.5),
    height: "100%",
  },
  cardHeader: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    flexWrap: "wrap",
    gap: theme.spacing(1.5),
    marginBottom: theme.spacing(2),
  },
  headerTitleWrap: {
    display: "flex",
    alignItems: "center",
    gap: theme.spacing(1),
  },
  headerIcon: {
    color: theme.palette.primary.main,
  },
  headerTitle: {
    fontSize: "1.15rem",
    fontWeight: 700,
    color: "#1f2937",
  },
  headerControls: {
    display: "flex",
    alignItems: "center",
    gap: theme.spacing(1.5),
  },
  navGroup: {
    display: "flex",
    alignItems: "center",
    gap: theme.spacing(0.5),
  },
  navButton: {
    backgroundColor: "#2b2f36",
    color: "#fff",
    borderRadius: 10,
    padding: 6,
    "&:hover": { backgroundColor: "#1f2329" },
  },
  todayBtn: {
    textTransform: "none",
    fontWeight: 600,
    fontSize: "0.8rem",
    borderRadius: 10,
    padding: "4px 14px",
    backgroundColor: "#2b2f36",
    color: "#fff",
    "&:hover": { backgroundColor: "#1f2329" },
  },
  monthGrid: {
    display: "grid",
    gridTemplateColumns: "repeat(7, minmax(0, 1fr))",
    border: "1px solid #eef0f3",
    borderRadius: 12,
    overflow: "hidden",
  },
  weekdayCell: {
    textAlign: "center",
    fontSize: "0.72rem",
    fontWeight: 700,
    textTransform: "uppercase",
    letterSpacing: "0.04em",
    color: "#9aa4b2",
    backgroundColor: "#f8fafc",
    padding: "10px 0",
    borderBottom: "1px solid #eef0f3",
  },
  dayCell: {
    minHeight: 84,
    padding: theme.spacing(1),
    borderRight: "1px solid #f1f3f6",
    borderBottom: "1px solid #f1f3f6",
    cursor: "pointer",
    display: "flex",
    flexDirection: "column",
    gap: 6,
    transition: "background-color 0.15s ease",
    "&:hover": { backgroundColor: "#f8fbff" },
    "&:nth-child(7n)": { borderRight: "none" },
  },
  dayCellOutside: {
    backgroundColor: "#fcfcfd",
    "& $dayNumber": { color: "#cbd5e1" },
  },
  dayCellSelected: {
    backgroundColor: "#eef4ff",
    boxShadow: "inset 0 0 0 2px #1162FE",
    "&:hover": { backgroundColor: "#eef4ff" },
  },
  // Past day still holding a Pending/Rescheduled follow-up.
  dayCellOverdue: {
    boxShadow: "inset 0 0 0 1px #f0a9a1",
    backgroundColor: "#fffafa",
  },
  dayNumber: {
    alignSelf: "flex-start",
    fontSize: "0.82rem",
    fontWeight: 600,
    color: "#374151",
    lineHeight: 1.4,
  },
  dayNumberToday: {
    display: "inline-flex",
    alignSelf: "flex-start",
    alignItems: "center",
    justifyContent: "center",
    width: 22,
    height: 22,
    borderRadius: "50%",
    backgroundColor: "#eef4ff",
    color: "#1162FE",
    fontWeight: 700,
  },
  dotRow: {
    display: "flex",
    alignItems: "center",
    flexWrap: "wrap",
    gap: 4,
  },
  dot: {
    width: 8,
    height: 8,
    borderRadius: "50%",
    flexShrink: 0,
  },
  overflowCount: {
    fontSize: "0.68rem",
    fontWeight: 700,
    color: "#6b7280",
  },
  countLabel: {
    fontSize: "0.68rem",
    fontWeight: 600,
    color: "#9aa4b2",
    marginTop: "auto",
  },
  overdueLabel: {
    color: "#c0392b",
  },
  legend: {
    display: "flex",
    alignItems: "center",
    flexWrap: "wrap",
    gap: theme.spacing(2),
    marginTop: theme.spacing(2),
  },
  legendItem: {
    display: "flex",
    alignItems: "center",
    gap: 6,
  },
  legendLabel: {
    fontSize: "0.75rem",
    fontWeight: 600,
    color: "#6b7280",
  },
}));
